import React from 'react';
import resume from '../data/resume';

const Contact = () => {
  const sectionStyle = {
    textAlign: 'left'
  };

  const promptStyle = {
    fontSize: '14px',
    color: '#00FF00',
    margin: '0 0 5px 0',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const headingStyle = {
    fontSize: 'clamp(16px, 4.5vw, 18px)',
    fontWeight: 'bold',
    margin: '0 0 15px 0',
    letterSpacing: '2px',
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace',
    paddingLeft: 'clamp(12px, 4vw, 30px)'
  };

  const contactStyle = {
    padding: '10px',
    border: '1px solid #00FF00',
    backgroundColor: '#001100',
    marginLeft: 'clamp(12px, 4vw, 30px)'
  };

  const emailStyle = {
    fontSize: '14px',
    margin: '0',
    lineHeight: '1.6',
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace',
    wordBreak: 'break-word'
  };

  const buttonStyle = {
    display: 'inline-block',
    marginTop: '10px',
    marginRight: '10px',
    padding: '5px 10px',
    border: '1px solid #00FF00',
    color: '#00FF00',
    backgroundColor: 'transparent',
    fontSize: 'clamp(10px, 2.5vw, 11px)',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace',
    cursor: 'pointer',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.3s ease, color 0.3s ease'
  };

  const buttonHover = {
    backgroundColor: '#00FF00',
    color: '#001100'
  };

  return (
    <section style={sectionStyle}>
      <div style={promptStyle}>$ cat contact.info</div>
      <h2 style={headingStyle}>[ CONTACT ]</h2>
      <div style={contactStyle}>
        <p style={emailStyle}>
          ┌─ Email: {resume.email}{" "}
          <a
            href={`mailto:${resume.email}`}
            style={buttonStyle}
            onMouseEnter={e => Object.assign(e.target.style, buttonHover)}
            onMouseLeave={e => Object.assign(e.target.style, buttonStyle)}
          >
             Email Me
          </a>
        </p>
        <p style={emailStyle}>├─ Phone: {resume.phone}</p>
        <p style={emailStyle}>├─ Location: {resume.location}</p>
        <p style={emailStyle}>├─ Status: {resume.available ? 'Available for opportunities' : 'Currently engaged'}</p>
        <p style={emailStyle}>├─ Resume:{" "}
          <a
            href={resume.resumeUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={buttonStyle}
            onMouseEnter={e => Object.assign(e.target.style, buttonHover)}
            onMouseLeave={e => Object.assign(e.target.style, buttonStyle)}
          >
             Download Resume
          </a>
        </p>
        <p style={emailStyle}>
          └─ LinkedIn:{" "}
          <a
            href={resume.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            style={buttonStyle}
            onMouseEnter={e => Object.assign(e.target.style, buttonHover)}
            onMouseLeave={e => Object.assign(e.target.style, buttonStyle)}
          >
            Connect on LinkedIn
          </a>
        </p>
      </div>
    </section>
  );
};

export default Contact;
